import { Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow, tokens } from "@fluentui/react-components";
import LinkWithIcon from "../../LinkWithIcon";

export default function FlightOps_Overview_OrphanedBuilds() {
    return (
        <>
            <p>
                The following builds are orphaned and have no branch assignment. They cannot be promoted to any ring until they are assigned to a branch.
            </p>

            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>Build</TableHeaderCell>
                        <TableHeaderCell>Ever seen</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <TableRow>
                        <TableCell><LinkWithIcon href="/flightops/builds/c13e056b-bc0f-4d9d-9e2a-8b3f9895c904" text="1.2.0.0" /></TableCell>
                        <TableCell><span style={{ color: tokens.colorStatusDangerForeground1 }}>No</span></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </>
    );
}